export default __webpack_public_path__ + "static/media/1-icon.305a4c83.svg";